<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-back">

	<template v-slot:head>

		Change Filters

	</template>

	<template v-slot:default>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title class="title">Games</core-filter-advanced-title>

			<app-filter-template-games-general filter="hindex" :hideExpansion="true" />

			<app-filter-template-games-count filter="hindex" />

			<app-filter-template-common-tags filter="hindex" label="Own Profile only" v-if="isPrivate" />
			
		</core-filter-advanced-inputs>
		
		<core-filter-advanced-inputs>
			
			<core-filter-advanced-title>Collection</core-filter-advanced-title>

			<app-filter-template-collection-general filter="hindex" />

			<app-filter-template-collection-status filter="hindex" :hideDuplicates="true" />
			
		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>
			
			<core-filter-advanced-title>Ratings</core-filter-advanced-title>

			<app-filter-template-collection-user filter="hindex" />

			<app-filter-template-collection-community filter="hindex" />
			
		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title>Plays</core-filter-advanced-title>

			<app-filter-template-plays-general filter="hindex" :hideExpansion="true" :hideFirst="true" :hideLast="true" />

			<app-filter-template-plays-players filter="hindex" label="Own Profile only" v-if="isPrivate" />

			<app-filter-template-plays-locations filter="hindex" label="Own Profile only" v-if="isPrivate" />
			
		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>
			
			<core-filter-advanced-title>Other</core-filter-advanced-title>

			<app-filter-template-common-users filter="hindex" />

			<app-filter-template-common-designers filter="hindex" />
				
			<app-filter-template-common-artists filter="hindex" />
				
			<app-filter-template-common-publishers filter="hindex" />
				
			<app-filter-template-common-categories filter="hindex" />
				
			<app-filter-template-common-mechanics filter="hindex" />
				
			<app-filter-template-common-subdomains filter="hindex" />

			<app-filter-template-common-families filter="hindex" />
			
		</core-filter-advanced-inputs>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading">Apply</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],

	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			validation: {}

		}

	},

	created: function() {

		this.$store.commit('filter/hindex/set', this.data.model.filter)

	},

	computed: {

		isPrivate: function() {

			return !this.data.model.public

		},

        isUpgraded: function() {

			return this.$store.getters['session/upgraded']

		},

		atLimit: function() {

            return this.remaining <= 0

        },

        limit: function() {

            return this.$store.getters['session/user'].hindex.limit

        },

        remaining: function() {

            return this.$store.getters['session/user'].hindex.remaining

        }

	},

	methods: {

		onConfirmClick: function() {

			this.$emit('close')

			this.data.model.filter = this.$store.getters['filter/hindex']

			this.$pubsub.$emit('open.modal', {
				id: 'hindexCreate',
				model: this.$util.copy(this.data.model),
				index: this.data.index
			})

		},

		onClose: function() {

			this.$emit('close')
			
			this.$pubsub.$emit('open.modal', {
				id: 'hindexCreate',
				model: this.$util.copy(this.data.model),
				index: this.data.index
			})

		}

	}

}

</script>

<style scoped>

.message {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    font-weight: 400;
    background-color: #254b5f;
    border-radius: 10px;
    padding: 20px;
    margin: 20px 20px;
}

.title {
	margin-top: 15px;
}

</style>